import React from 'react';
import {Layout, Tabs, Card} from 'antd';
import appColors from '../../style/theme';
import SSDNA3DMPLogic from '../SSDNA3DMPX/SSDNA3DMPLogic';
import {BarChartOutlined, BuildOutlined, DeploymentUnitOutlined, EyeOutlined, NodeIndexOutlined} from '@ant-design/icons';
import {useState} from 'react';
import ModelLogic from './ModelLogic';
import MolecularDockingLogic from '../MolecularDockingX/MolecularDockingLogic';
import MolecularDynamicsLogic from '../MolecularDynamicsX/MolecularDynamicsLogic';
import ComputationaChemistyLogic from '../CompChes/CompChesLogic';
import MathematicalMpage from '../MathematicalModel/MathModel';
const {Content} = Layout;

const ModelPage = () => {
  const [TAUno, setTAUno] = useState(appColors['ColorA']);
  const [GAUno, setGAUno] = useState('white');
  // others
  const [TUno, setTUno] = useState('transparent');
  const [GUno, setGUno] = useState(appColors['ColorB']);
  const [Tno, setTno] = useState('transparent');
  const [Gno, setGno] = useState(appColors['ColorC']);
  const [To, setTo] = useState('transparent');
  const [Go, setGo] = useState(appColors['ColorD']);
  const [ToI, setToI] = useState('transparent');
  const [GoI, setGoI] = useState(appColors['ColorE']);
  const [ToII, setToII] = useState('transparent');
  const [GoII, setGoII] = useState(appColors['ColorF']);
  const changeColor1 = (key) => {
    if (key === 'one') {
      setTAUno(appColors['ColorA']);
      setGAUno('white');
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'two') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno(appColors['ColorB']);
      setGUno('white');
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'three') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno(appColors['ColorC']);
      setGno('white');
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'four') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo(appColors['ColorD']);
      setGo('white');
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'five') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI(appColors['ColorE']);
      setGoI('white');
      setToII('transparent');
      setGoII(appColors['ColorF']);
    } else if (key === 'six') {
      setTAUno('transparent');
      setGAUno(appColors['ColorA']);
      setTUno('transparent');
      setGUno(appColors['ColorB']);
      setTno('transparent');
      setGno(appColors['ColorC']);
      setTo('transparent');
      setGo(appColors['ColorD']);
      setToI('transparent');
      setGoI(appColors['ColorE']);
      setToII(appColors['ColorF']);
      setGoII('white');
    }
  };
  const items_ = [
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: TAUno,
        marginLeft: '3vh',
      }}
      cover={
        <EyeOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GAUno}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', fontSize: '3vh', marginTop: '-4vh', color: GAUno}}><b>Overview</b></p>
    </Card>, key: 'one', children: <SSDNA3DMPLogic/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: TUno,
        marginLeft: '3vh',
      }}
      cover={
        <BuildOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GUno}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', fontSize: '2vh', marginTop: '-4vh', color: GUno}}><b>3D ssDNA <br/>Modeling Pipeline</b></p>
    </Card>, key: 'two', children: <ModelLogic/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: Tno,
        marginLeft: '3vh',
      }}
      cover={
        <NodeIndexOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: Gno}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '2vh', marginTop: '-4vh', color: Gno}}><b>Molecular<br/>Docking</b></p>
    </Card>, key: 'three', children: <MolecularDockingLogic/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: To,
        marginLeft: '3vh',
      }}
      cover={
        <DeploymentUnitOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: Go}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '2vh', marginTop: '-4vh', color: Go}}><b>Molecular<br/>Dynamics</b></p>
    </Card>, key: 'four', children: <MolecularDynamicsLogic/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: ToI,
        marginLeft: '3vh',
      }}
      cover={
        <BarChartOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GoI}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '2vh', marginTop: '-4vh', color: GoI}}><b>Computational<br/>Chemistry</b></p>
    </Card>, key: 'five', children: <ComputationaChemistyLogic/>},
    {label: <Card
      style={{
        width: 200,
        height: '25.5vh',
        background: ToII,
        marginLeft: '3vh',
      }}
      cover={
        <EyeOutlined style={{marginLeft: '50%', transform: 'translateX(-50%)', fontSize: '20vh', color: GoII}}/>
      }bordered={false}
      hoverable={true}
    >
      <p style={{background: 'transparent', textAlign: 'center', fontSize: '2vh', marginTop: '-4vh', color: GoII}}><b>Mathmatical<br/>Model</b></p>
    </Card>, key: 'six', children: <MathematicalMpage/>},
  ];
  return (
    <Layout style={{background: 'transparent'}}>
      <Content style={{padding: '24px', background: 'transparent'}}>
        <Tabs
          centered='true'
          defaultActiveKey="1"
          type="line"
          items={items_}
          size='small'
          onTabClick={changeColor1}
          tabBarGutter='-1vh'
        />
      </Content>
    </Layout>
  );
};

export default ModelPage;
